import { DesignElementBrandedPart, DesignElementGroupableBase } from "./base";
import { DesignTokenOrigin, DesignTokenOriginPart, DesignTokenTypedData, } from "./tokens";
import { z } from "zod";
//
// Overrides
//
export const ThemeOverrideOriginPart = DesignTokenOriginPart;
export const ThemeOverrideOrigin = DesignTokenOrigin;
export const ThemeOverride = DesignTokenTypedData.and(z.object({
    tokenPersistentId: z.string(),
    origin: ThemeOverrideOrigin.optional()
        .nullable()
        .transform((v) => v !== null && v !== void 0 ? v : undefined),
}));
//
// Theme data
//
export const ThemeElementData = z.object({
    value: z.object({
        overrides: z.array(ThemeOverride),
    }),
});
//
// Theme
//
export const ThemeOriginPart = z.object({});
export const ThemeOriginObject = z.object({
    id: z.string(),
    name: z.string(),
    parentModeId: z.string().optional(),
});
export const ThemeOriginSource = z.object({
    sourceId: z.string(),
    sourceObjects: z.array(ThemeOriginObject),
});
export const ThemeOrigin = z.object({
    sources: z.array(ThemeOriginSource),
});
export const Theme = DesignElementGroupableBase.extend(DesignElementBrandedPart.shape).extend({
    origin: ThemeOrigin.optional(),
    overrides: z.array(ThemeOverride),
    codeName: z.string(),
    collectionPersistentIds: z.string().array(),
});
